// extracted by mini-css-extract-plugin
export default {"container":"Work_container__992xG","mymove":"Work_mymove__TWoME","card":"Work_card__zQd2B","img":"Work_img__7SddZ","title":"Work_title__+XhkB","info":"Work_info__Q65Ax"};